import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Prefrence } from './interfaces';
import { DataService } from './services/data.service';
import { LoggerService } from './services/logger.service';
import { ValidationService } from './services/validation.service';
import { PdfGeneratorServiceService } from 'src/app/shared/pdf-generator-service.service';

@Component({
  selector: 'app-pierhippnv',
  templateUrl: './pierhippnv.component.html',
  styleUrls: ['./pierhippnv.component.css']
})
export class PIERHIPPNVComponent implements OnInit{
  //contextCd: string = '';
  //subContextCd: string = '';
  preference: Prefrence | null = null;
  email: string | undefined ='';
  tollfreeNo: string | undefined |  null ='';
  faxNo: string | undefined | null='';
  errorMessageIntialData: string = '';
  address: string='';
  emailTo: string='';
  logoImage: any;
  applicationPDF: any;

  ngOnInit(): void {
    this.logoImage = 'app/module/pierhippnv/assets/img/NV_Header.jpg';
    //this.contextCd = this.route.snapshot.url[0].path;
    //this.subContextCd = this.contextCd.substring(8);
    this.dataService.getPreference().subscribe({
      next: (preferences: Prefrence) => {
        this.preference = preferences;

        this.faxNo= ValidationService.formatPhoneNumber(preferences.preferenceValues?.['FAX_NUM']);
        this.tollfreeNo= ValidationService.formatPhoneNumber(preferences.preferenceValues?.['TOLL_FREE_NUM']);
        this.email= preferences.preferenceValues?.['EMAIL_ID'];
        this.applicationPDF = this.preference.paperApplication;
        this.emailTo='mailto:'+this.email;
        this.address=''+preferences.preferenceValues?.['MAIL_OFFICE']+', '+preferences.preferenceValues?.['MAIL_ADDRESS1_TXT']+', '+preferences.preferenceValues?.['MAIL_ADDRESS2_TXT']+', '+preferences.preferenceValues?.['MAIL_CITY']+', '+preferences.preferenceValues?.['MAIL_STATE_CD']+' '+preferences.preferenceValues?.['MAIL_ZIPCD'];
      },
      error:  (err: HttpErrorResponse) => {this.logger.log(err.message);
        const msg = 'Unable to get the Preference details: '+err.message;
        this.errorMessageIntialData = msg;

      }});


  }

  constructor( private route: ActivatedRoute,
    private dataService: DataService,
    private logger: LoggerService,
    private pdfService: PdfGeneratorServiceService
    ) {}

     openPaperApplication(){
      this.pdfService.generatePdf(this.applicationPDF, 'PaperApplication.pdf');
  }

}
